import { render, staticRenderFns } from "./AncillarySeatMapPassengerNarrow.vue?vue&type=template&id=5b520c7d&scoped=true"
import script from "./AncillarySeatMapPassengerNarrow.vue?vue&type=script&lang=js"
export * from "./AncillarySeatMapPassengerNarrow.vue?vue&type=script&lang=js"
import style0 from "./AncillarySeatMapPassengerNarrow.vue?vue&type=style&index=0&id=5b520c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b520c7d",
  null
  
)

export default component.exports